import { createContext, useContext, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

const FilterContext = createContext(null);

const DEFAULT_FROM = "2026-01-01";
const todayStr = () => new Date().toISOString().slice(0, 10);

export const FilterProvider = ({ children }) => {
  const [fromDate, setFromDate] = useState(DEFAULT_FROM);
  const [toDate, setToDate] = useState(todayStr());

  const { data: options } = useQuery({
    queryKey: ["filters"],
    queryFn: async () => (await api.get("/analytics/filters")).data,
  });

  const params = useMemo(() => {
    const p = {};
    if (fromDate) p.from_date = fromDate;
    if (toDate) p.to_date = toDate;
    return p;
  }, [fromDate, toDate]);

  const queryString = useMemo(() => new URLSearchParams(params).toString(), [params]);

  const clear = () => {
    setFromDate(DEFAULT_FROM);
    setToDate(todayStr());
  };

  return (
    <FilterContext.Provider
      value={{ fromDate, setFromDate, toDate, setToDate, params, queryString, clear, options, DEFAULT_FROM }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilters = () => useContext(FilterContext);
